<template>
  <div class="pagination">
    <div class="grid-x grid-padding-x align-middle">
      <div class="cell shrink">
        <div class="pagination__count">Showing {{ start }} to {{ end }} of {{ total }}</div>
      </div>

      <div class="cell auto text-right">
        <div class="pagination">
          <div :class="['pagination__arrow pagination__arrow--prev', prev ? 'active' : '']"
               @click="prev ? paginate(prev) : null">
            <i class="fa-angle-left fas"></i>
          </div>

          <div :class="['pagination__arrow pagination__arrow--next', next ? 'active' : '']"
               @click="next ? paginate(next) : null">
            <i class="fa-angle-right fas"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'prev',
    'next',
    'start',
    'end',
    'total'
  ],
  methods: {
    paginate (page) {
      this.$emit('paginate', page)
    }
  }
}
</script>

<style lang="scss">
@import '../styles/mixins';
@import '../styles/variables';

.pagination {
  padding: 5px 0;
  line-height: 0;

  &__count {
    font-size: 14px;
    font-style: italic;
  }

  &__arrow {
    background: $lightest-gray;
    border: 1px solid $medium-gray;
    border-radius: $global-radius;
    display: inline-block;
    height: 30px;
    overflow: hidden;
    position: relative;
    width: 30px;

    svg {
      @include transform(translate(-50%, -50%));
      color: #cccccc;
      font-size: 18px;
      left: 50%;
      position: absolute;
      top: 50%;
    }

    &.active {
      cursor: pointer;

      svg {
        color: $dark-gray;
      }

      &:hover {
        background: darken($lightest-gray, 10%);

        svg {
          color: darken($dark-gray, 10%);
        }
      }
    }
  }
}

.no-padding .pagination > .grid-padding-x {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/globals/pagination.vue